// extracted by mini-css-extract-plugin
module.exports = {"collection-manage":"collection-manage_collection-manage__1oPPT"};